import PropTypes from 'prop-types';
import SubtitleLink from './subtitleLink';
import './subtitle.scss';

const Subtitle = ({ geographical, shouldShowRegion, className }) => {
  const {
    resort = null,
    area,
    country,
    region,
  } = geographical || {};

  return (
    <div className={className || 'gw-subtitle'}>
      <SubtitleLink
        geographicalNode={resort}
        useDivider
      />
      <SubtitleLink
        geographicalNode={area}
        useDivider={!resort}
      />
      { shouldShowRegion && !resort && (
        <SubtitleLink
          geographicalNode={region}
          useDivider
        />
      )}
      { (!resort || !area) && (
        <SubtitleLink geographicalNode={country} />
      )}
    </div>
  );
};

Subtitle.propTypes = {
  geographical: PropTypes.shape({
    resort: PropTypes.shape({}),
    country: PropTypes.shape({}),
    area: PropTypes.shape({}),
    region: PropTypes.shape({}),
  }).isRequired,
  shouldShowRegion: PropTypes.bool,
  className: PropTypes.string,
};

Subtitle.defaultProps = {
  shouldShowRegion: false,
  className: '',
};

export default Subtitle;
